import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, Validators} from '@angular/forms';
import {HealthInsuranceService} from '../../../services/health-insurance.service';
import {Option, Response} from '../../../model/GeneralModels';
import {GeneralService} from '../../../services/general.service';
import {HasElementRef, MapComponent} from '../../../Elements/map/map/map.component';

@Component({
  selector: 'app-near-me',
  templateUrl: './near-me.component.html',
  styleUrls: [
    '../../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ],
  styles: [`
    .tool-box {
      margin: 20px;
    }
    .row {
      margin-left: 0;
      margin-right: 0;
    }
  `]
})
export class NearMeComponent implements OnInit, AfterViewInit {
  @ViewChild('mapComponent') map: MapComponent;
  searchForm = this.fb.group({
    companyName: ['', Validators.required],
    stateName: [''],
    productName: ['HEALTH', Validators.required],
    type: [''],
    longitude: ['', Validators.required],
    latitude: ['', Validators.required],
    distance: ['10', Validators.required]
  });
  locations: any[] = [];
  companies: Option[] = [];
  states: Option[] = [];
  types: Option[] = [];
  showNavigation = false;
  isLoaded = false;

  constructor(private fb: FormBuilder,
              private service: HealthInsuranceService,
              private generalService: GeneralService) { }

  ngOnInit() {
    this.generalService.getClientCompanyList('HEALTH').subscribe((response: Response) => {
      if (response.success) {
        response.data.forEach(company => {
          console.log(company);
          this.companies[this.companies.length] = new Option(company.label, company.value);
        });
        console.log(this.companies);
        if (this.companies.length === 1) {
          this.searchForm.controls.companyName.patchValue(this.companies[0].value);
          this.getTypesList();
        }
      }
    });
  }

  ngAfterViewInit(): void {
    this.isLoaded = true;
    console.log('map after init: ', this.map);
  }

  getTypesList() {
    if (this.searchForm.controls.companyName.valid) {
      this.generalService.getTypeList('HEALTH', this.searchForm.controls.companyName.value).subscribe(
        (response: Response) => {
        if (response.success) {
          this.types = response.data;
        }
      });
    }
  }

  search() {
    console.log(this.searchForm.value);
    if (this.searchForm.valid) {
      this.locations = [];
      this.generalService.searchNearMe(this.searchForm.value).subscribe((response: Response) => {
        if (response.success) {
          this.locations = response.data;
        }
        console.log(this.locations);
      });
    }
  }

  setLocation($event) {
    this.searchForm.controls.latitude.patchValue($event[0]);
    this.searchForm.controls.longitude.patchValue($event[1]);
    if (this.searchForm.valid) {
      this.search();
    }
  }

  showRoute(options: any) {
    this.map.getNavigation(options);
    this.showNavigation = false;
  }

  clearLocations() {
    this.locations = [];
  }

  goToCurrentLocation() {
    if (this.isLoaded) {
      this.map.goToCurrentLocation();
    }
  }

  getSelectedFeature() {
    if (this.isLoaded) {
      return this.map.selectedFeature;
    }
    return null;
  }
}
